module.exports = __webpack_public_path__ + "img/persons_shape.4659986f.svg";